import { render, staticRenderFns } from "./to_examine.vue?vue&type=template&id=bcd2c7d2&scoped=true&"
import script from "./to_examine.vue?vue&type=script&lang=js&"
export * from "./to_examine.vue?vue&type=script&lang=js&"
import style0 from "./to_examine.vue?vue&type=style&index=0&id=bcd2c7d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd2c7d2",
  null
  
)

export default component.exports